<div class="modal-header">
    <h4>{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="form" autocomplete="off">
        <ng-container *ngFor="let formField of titlesAndLists; let i=index">
            <mat-form-field style="margin-top: 8px;" [ngClass]="{'col-12': formField.columnSize === 12, 'col-8': formField.columnSize === 8,
						'col-7': formField.columnSize === 7, 'col-5': formField.columnSize === 5,
						'col-6': formField.columnSize === 6, 'col-4': formField.columnSize === 4,
						'fild-required': hasRequiredField(form.get(formField.formControlName)) || formField.formControlName == 'primaryEmail'}">
                <mat-label class="mat-label">{{formField.title}}:</mat-label>
                <ng-container *ngIf="formField.list; else normalInput">
                    <ng-container *ngIf="formField.formControlName === 'country'; else normalSelectInput">

                    <mat-select formControlName="{{formField.formControlName}}" name="{{formField.formControlName}}" [required]="hasRequiredField(form.get(formField.formControlName))" (selectionChange)="selectedCountry = $event.value">
                        <mat-option *ngFor="let item of formField.list" [value]="(item.code) ? item.code : item"> 
                           {{ item.description ? item.description : item.code ? item.code : item }}
                        </mat-option>
                    </mat-select>
                    </ng-container>
                     <ng-template #normalSelectInput>
                        <mat-select formControlName="{{formField.formControlName}}" name="{{formField.formControlName}}" [required]="hasRequiredField(form.get(formField.formControlName))">
                           <ng-container *ngIf="formField.formControlName === 'state'; else defaultSelectOption">
                                <mat-option *ngFor="let item of getFilteredList(formField)" [value]="(item.code) ? item.code : item"> 

                                <ng-container *ngIf="formField.formControlName === 'state'; else defaultOption">
                                    {{ item.description && item.code ? (item.code + ' - ' + item.description) : item.description ? item.description : item.code ? item.code : item }}
                                </ng-container>
                                <ng-template #defaultOption>
                                    {{ item.description ? item.description : item.code ? item.code : item }}
                                </ng-template>
                                </mat-option>
                           </ng-container>
                            <ng-template #defaultSelectOption>
                            <mat-option *ngFor="let item of formField.list" [value]="(item.code) ? item.code : item"> 

                                <ng-container *ngIf="formField.formControlName === 'state'; else defaultOption">
                                    {{ item.description && item.code ? (item.code + ' - ' + item.description) : item.description ? item.description : item.code ? item.code : item }}
                                </ng-container>
                                <ng-template #defaultOption>
                                    {{ item.description ? item.description : item.code ? item.code : item }}
                                </ng-template>
                            </mat-option>
                            </ng-template>
                
                    </mat-select>
                     </ng-template>
                   
                </ng-container>
                <ng-template #normalInput>
                    <input [ngClass]="{'input-disabled': isModifyOnlyDescription }"
                            *ngIf="formField.title != 'Description'"
                            matInput
							autocomplete="off"
                            formControlName="{{formField.formControlName}}"
                            maxlength="{{formField.maxLength}}"
                            [required]="hasRequiredField(form.get(formField.formControlName))"
                            [readonly]="isModifyOnlyDescription">
                    <input *ngIf="formField.title == 'Description'" matInput formControlName="{{formField.formControlName}}" maxlength="{{formField.maxLength}}" [required]="hasRequiredField(form.get(formField.formControlName))">
                </ng-template>
                <mat-error *ngIf="form.get(formField.formControlName).hasError('required')">
                    <strong>{{ 'APPLICATIONS.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
                </mat-error>
                <mat-error *ngIf="form.get(formField.formControlName).hasError('pattern')">
                    <strong>{{ 'DEBITS_AND_CREDITS.VALIDATION.INVALID_EMAIL' | translate }}</strong>
                </mat-error>
                <mat-error *ngIf="form.get(formField.formControlName).hasError('maxlength')">
                    <strong>{{ 'APPLICATIONS.VALIDATION.MAX_LENGTH_REACHED' | translate }}</strong>
                </mat-error>
            </mat-form-field>
        </ng-container>
    </form>
</div>
<div class="modal-footer">
    <button mat-raised-button color="accent" class="margin-buttons-form-field" (click)="process()" [disabled]="loaders.process" [ngClass]="{'kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light': loaders.process}">
		<ng-container *ngIf="!loaders.process && action === 'add' && !form.disabled">
			Add {{buttonNameForComponent}}
		</ng-container>
		<ng-container *ngIf="!loaders.process && action === 'edit' && !form.disabled">
			Update
        </ng-container>
		<ng-container *ngIf="!loaders.process && form.disabled">
			{{ 'MODAL_CONFIRMATION.ACCEPT' | translate }}
		</ng-container>
	</button>
</div>
